import React from "react"
import ContactFormFeatureComponent from "./ContactFormFeature"
import contactFormFeatureFactory from "./contactFormFeature.factory"

export { default as ContactFormFeatureQuery } from "./contactFormFeature.query"

export const ContactFormFeature = props => {
  const { data } = props
  const componentProps = { ...props, ...contactFormFeatureFactory.transform(data) }
  return <ContactFormFeatureComponent {...componentProps} />
}
